import SectionBase from '../base'
import { ILogInRequest, IRegisterRequest } from './types'

const defaultLogInData = {
  grant_type: 'password',
  client_id: 'MzA4MDBkNzAtODIyMS00N2ZhLThiMmQtY2JjZTNjZmEwNWEz',
  provider: 'Dash',
}

export default class Auth extends SectionBase {
  public logIn = (data: ILogInRequest) =>
    this.service.request({
      url: '/auth',
      method: 'POST',
      data: {
        ...defaultLogInData,
        ...data,
      },
    })
  public logOut = () =>
    this.service.request({
      url: '/auth/logout',
      method: 'PUT',
    })
  public register = (data: IRegisterRequest) =>
    this.service.request({
      url: '/register',
      method: 'POST',
      data: {
        ...data,
      },
    })
}
